/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TournamentAdminItemInputDto = {
  /**
   * 항목 이름
   */
  name: string;
  /**
   * IMAGE | YOUTUBE_SHORTS
   */
  sourceType: TournamentAdminItemInputDto.sourceType;
  /**
   * IMAGE: S3 URL / YOUTUBE_SHORTS: 유튜브 URL
   */
  mediaUrl: string;
};
export namespace TournamentAdminItemInputDto {
  /**
   * IMAGE | YOUTUBE_SHORTS
   */
  export enum sourceType {
    IMAGE = "IMAGE",
    YOUTUBE_SHORTS = "YOUTUBE_SHORTS",
  }
}
